import { createSelector } from '@reduxjs/toolkit';

import { selectVisibleWellsSettings } from 'app/components/pages/WellPlannerPage/PlanMapWidget/WellControl/selectors';
import { AGGREGATE_WELLS_LIMIT } from 'helpers/constants';
import { CurveType, EmissionCurvesType, WidgetCurveType } from 'types/Curve';
import { RootState } from 'types/RootState';

import { initialState } from './slice';

export const selectPlanProdCurvesSettingsDomain = (state: RootState) => state?.planProdCurvesSettings || initialState;

export const selectCurveSelectionValues = createSelector(
  [selectPlanProdCurvesSettingsDomain],
  (state) => state.curveSelection[WidgetCurveType.PRODUCTION],
);
export const selectCurveEmissoinSelectionValues = createSelector(
  [selectPlanProdCurvesSettingsDomain],
  (state) => state.curveSelection[WidgetCurveType.EMISSIONS],
);
export const selectActiveCurveEmissoinValues = createSelector(
  [selectCurveEmissoinSelectionValues],
  (emissionSelectionValues) => {
    return Object.keys(emissionSelectionValues).filter((key) => emissionSelectionValues[key as EmissionCurvesType]);
  },
);

export const selectProductionCurveSelectionItemValue = createSelector(
  [selectPlanProdCurvesSettingsDomain, (state: RootState, id: CurveType) => id],
  (curveSelectionValues, id) => curveSelectionValues.curveSelection[WidgetCurveType.PRODUCTION][id],
);

export const selectEmissionsCurveSelectionItemValue = createSelector(
  [selectPlanProdCurvesSettingsDomain, (state: RootState, id: EmissionCurvesType) => id],
  (curveSelectionValues, id) => curveSelectionValues.curveSelection[WidgetCurveType.EMISSIONS][id],
);

export const selectCumulativeProductionValue = createSelector(
  [selectPlanProdCurvesSettingsDomain],
  (state) => state.cumulativeProduction,
);

export const selectIsAggregateWellsReached = createSelector(
  [selectVisibleWellsSettings],
  (visibleWellsSettings) => visibleWellsSettings.length > AGGREGATE_WELLS_LIMIT,
);

export const selectAggregateProductionValue = createSelector(
  [selectPlanProdCurvesSettingsDomain],
  (state) => state.aggregateProduction,
);

export const selectPredictionModelsValues = createSelector(
  [selectPlanProdCurvesSettingsDomain],
  (state) => state.predictionModels,
);
export const selectIsErrorsEnabled = createSelector(
  [selectPlanProdCurvesSettingsDomain],
  (state) => state.predictionModels.planned.errors,
);
export const selectIsPredictionEnabled = createSelector(
  [selectPlanProdCurvesSettingsDomain],
  (state) => state.predictionModels.planned.general,
);
